import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { SaveDataState } from '../../../redux/reducers/getSaveData/saveDataReducer';
import { getProfileAttributes, putProfileAttributes, resetGetProfileAttributes } from '../../../redux/actions/profile/profile';
import { ProfileOverviewState } from '../../../redux/reducers/getProfile/getProfileOverviewReducer';
import { SaveResultState } from '../../../redux/reducers/getSaveData/saveResultReducer';
import PropertyData from '../../../types/parkingProperty/PropertyData';
import { ProfileAttributesState } from '../../../redux/reducers/getProfile/profileAttributes/getAttributesReducer';
import './VacantAskingRate.css'
import { useFormErrorContext } from '../../../utils/context/FormErrorContext';
import { useNavigation } from '../../../utils/context/NavigationContext';
import ErrorMessages from '../../../components/common/ErrorMessages/ErrorMessages';
import AIRPNumberInput from '../../../components/common/AIRPNumberInput/AIRPNumberInput';
import { selectProfileGetAttributes, selectProfileGetOverview, selectSaveData, selectSaveResult } from '../../../redux/selectors/exportSelectorPaths';

function VacantAskingRate() {
  const { t } = useTranslation('parking_property');

  const initialPropertyData: PropertyData = {
    "officeOccupiedArea": null,
    "retailOccupiedArea": null,
    "warehouseStorageOccupiedArea": null,
    "manufactureOtherIndustrialUseOccupiedArea": null,
    "officeVacantArea": null,
    "retailVacantArea": null,
    "warehouseStorageVacantArea": null,
    "manufactureOtherIndustrialUseVacantArea": null,
    "officeVacantRate": null,
    "retailVacantRate": null,
    "warehouseStorageVacantRate": null,
    "manufactureOtherIndustrialUseVacantRate": null,
  }

  const dispatch = useDispatch();
  const profileOverview: ProfileOverviewState = useSelector(selectProfileGetOverview);
  const profileAttributes: ProfileAttributesState = useSelector(selectProfileGetAttributes)
  const saveData: SaveDataState = useSelector(selectSaveData);
  const saveResultState: SaveResultState = useSelector(selectSaveResult);
  const [propertyData, setPropertyData] = useState<PropertyData>(initialPropertyData as PropertyData)
  const currentSnapshotId = Number(sessionStorage.getItem("currentSnapshotId") as string)
  const { clearErrors, errors } = useFormErrorContext()
  const { direction } = useNavigation()
  const isInternal = (sessionStorage.getItem("isInternalUser") as string) === "true"
  // const [hasErrors, setHasErrors] = useState(false);
  // const [rowErrors, setRowErrors] = useState({
  //   parkingDaily: false,
  //   parkingMonthly: false,
  //   parkingReserved: false,
  //   propertyOccupied: false,
  //   propertyVacant: false,
  //   propertyVacantAsking: false
  // });

  // const handleErrorsChange = (row: keyof typeof rowErrors, hasErrorsInRow: boolean) => {
  //   setRowErrors(prevState => {
  //     if (prevState[row] !== hasErrorsInRow) {
  //       return {
  //         ...prevState,
  //         [row]: hasErrorsInRow
  //       };
  //     }
  //     return prevState
  //   })
  // }

  useEffect(() => {
    dispatch(resetGetProfileAttributes())
    dispatch(getProfileAttributes(profileOverview.profile.profile_type_code, Number(sessionStorage.getItem("currentSnapshotId") as string)))
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (profileAttributes.data && !profileAttributes.loading) {
      setPropertyData({
        officeOccupiedArea: profileAttributes.data.officeOccupiedArea,
        retailOccupiedArea: profileAttributes.data.retailOccupiedArea,
        warehouseStorageOccupiedArea: profileAttributes.data.warehouseStorageOccupiedArea,
        manufactureOtherIndustrialUseOccupiedArea: profileAttributes.data.manufactureOtherIndustrialUseOccupiedArea,
        officeVacantArea: profileAttributes.data.officeVacantArea,
        retailVacantArea: profileAttributes.data.retailVacantArea,
        warehouseStorageVacantArea: profileAttributes.data.warehouseStorageVacantArea,
        manufactureOtherIndustrialUseVacantArea: profileAttributes.data.manufactureOtherIndustrialUseVacantArea,
        officeVacantRate: profileAttributes.data.officeVacantRate,
        retailVacantRate: profileAttributes.data.retailVacantRate,
        warehouseStorageVacantRate: profileAttributes.data.warehouseStorageVacantRate,
        manufactureOtherIndustrialUseVacantRate: profileAttributes.data.manufactureOtherIndustrialUseVacantRate,
      })
    }
  }, [profileAttributes.data, profileAttributes.loading])

  // useEffect(() => {
  //   const hasErrors = Object.values(rowErrors).some(error => error === true)
  //   setHasErrors(hasErrors)
  // }, [rowErrors])

  const handleCurrencyChange = (value: number | null, name: string) => {
    setPropertyData(oldParkingData => ({
      ...oldParkingData,
      [name]: value
    }))
  };

  useEffect(() => {
    if (saveData.saving) {
          clearErrors()
          const data = { ...profileAttributes.data, ...propertyData } as Record<string, unknown>
          const triggerSpectral = isInternal || direction !== "backward"
    
          dispatch(putProfileAttributes(profileOverview.profile.profile_type_code, currentSnapshotId, {
            "profile_attributes": data,
            "spectral_section": "vacant",
            "trigger_spectral": triggerSpectral,
            "is_internal": isInternal
        }))
    // if (saveData.saving) {
    //   if (hasErrors) {
    //     toast.error("Error going to next page: Values must be positive.")
    //     dispatch(resetSaving())
    //     dispatch(setNextActiveMenuItem(initialMenuItem))
    //     return
    //   }

    //   const data = { ...profileAttributes.data, ...propertyData } as Record<string, unknown>
    //   dispatch(putProfileAttributes(profileOverview.profile.profile_type_code, Number(sessionStorage.getItem("currentSnapshotId") as string), {
    //     "profileAttributes": data
    //   }))
    }
  }, [dispatch, profileAttributes.data, profileOverview.profile.profile_type_code, propertyData, saveData.saving, currentSnapshotId, direction, clearErrors, isInternal])

  useEffect(() => {
    if (saveResultState.status === 200) {
      dispatch(getProfileAttributes(profileOverview.profile.profile_type_code, Number(sessionStorage.getItem("currentSnapshotId") as string)))
    }
  }, [dispatch, profileOverview.profile.profile_type_code, saveResultState.status])

  return (
    <div className='partial-width'>
      <div className='property-section'>
        <p className='strong'>{t("propertyHeader")}</p>
        <ErrorMessages errors={errors}/>
        <table className='vacant-asking-rate-table' role="presentation">
          <thead>
            <tr><th colSpan={5}>{t("propertyTableTitle")}</th></tr>
            <tr>
              <th id='property-space-type' className='pier-datatable-clear-th' key="property-column-1-header">{t("propertyTableHeaderSpaceType")}</th>
              <th id='property-office' className='pier-datatable-clear-th' key="property-column-2-header" title={t("officeTooltip")}>{t("propertyTableHeaderOffice")}</th>
              <th id='property-retail' className='pier-datatable-clear-th' key="property-column-3-header" title={t("retailTooltip")}>{t("propertyTableHeaderRetail")}</th>
              <th id='property-warehouse' className='pier-datatable-clear-th' key="property-column-4-header" title={t("warehouseTooltip")}>{t("propertyTableHeaderWarehouse")}</th>
              <th id='property-manufacturing' className='pier-datatable-clear-th' key="property-column-5-header" title={t("manufacturingTooltip")}>{t("propertyTableHeaderManufacturing")}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{t("propertyTableRowVacantAsking")}</td>
              <td>
                <AIRPNumberInput 
                    name="officeVacantRate"
                    symbol='$'
                    placeholder='($/SF)'
                    textAlign='right'
                    initialValue={propertyData.officeVacantRate as number}
                    tooltip={t("officeTooltip")}
                    onChange={(value: number | null) => handleCurrencyChange(value, "officeVacantRate")}
                />
              </td>
              <td>
                <AIRPNumberInput 
                    name="retailVacantRate"
                    symbol='$'
                    placeholder='($/SF)'
                    textAlign='right'
                    initialValue={propertyData.retailVacantRate as number}
                    tooltip={t("retailTooltip")}
                    onChange={(value: number | null) => handleCurrencyChange(value, "retailVacantRate")}
                />
              </td>
              <td>
                <AIRPNumberInput 
                    name="warehouseStorageVacantRate"
                    symbol='$'
                    placeholder='($/SF)'
                    textAlign='right'
                    initialValue={propertyData.warehouseStorageVacantRate as number}
                    tooltip={t("warehouseTooltip")}
                    onChange={(value: number | null) => handleCurrencyChange(value, "warehouseStorageVacantRate")}
                />
              </td>
              <td>
                <AIRPNumberInput 
                    name="manufactureOtherIndustrialUseVacantRate"
                    symbol='$'
                    placeholder='($/SF)'
                    textAlign='right'
                    initialValue={propertyData.manufactureOtherIndustrialUseVacantRate as number}
                    tooltip={t("manufacturingTooltip")}
                    onChange={(value: number | null) => handleCurrencyChange(value, "manufactureOtherIndustrialUseVacantRate")}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default VacantAskingRate